<template>
  <div>
    <label class="form-label block-head"><b>{{ $t('cameras.stream.title') }}</b></label>

    <div class="grid-inline">
      <input
        type="text"
        class="input"
        id="stream-link"
        v-model="StreamLink"
        :disabled="connectionTested"
        placeholder="rtsp://user:pass@ip:port/path"
      />
      <button
        v-if="!connectionTested"
        type="button"
        class="btn-solid primary"
        @click="testConnectCamera"
      >
        {{ $t('cameras.stream.testConnection') }}
      </button>
    </div>

    <div v-if="isLoading" class="loading-wrap">
      <div class="loader"></div>
    </div>

    <div class="frame-container" v-if="capturedFrame && connectionError === false">
      <!-- image is drawn by parent DZ tool, keep container for spacing -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import { ref } from 'vue'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'

import { useCompanyStore } from '@/stores/CompanyStore'
import { parseDeviceUrl } from '@/api/deviceUrl'

export default {
    name: 'CameraStreamSettings',
    
    components: {
      
    },

    emits: ["streamlink", "capturedframe"],

    setup(props, { emit }) {
        const toast = useToast()
        const { t } = useI18n()

        const companyStore = useCompanyStore()
      
        const StreamLink = ref('')
        const capturedFrame = ref(null)
        const connectionError = ref(false)
        const connectionTested = ref(false)

        const isLoading = ref(false)


        const testConnectCamera = async () => {
            connectionError.value = false
            isLoading.value = true
            try {
                const { httpBase, proxied } = parseDeviceUrl(companyStore.company.SocketioDeviceURL)

                const response = await axios.get(`${httpBase}/camera_connection_test`, {
                    params: { cameraStreamLink: StreamLink.value },
                    responseType: 'blob',
                    withCredentials: proxied
                })
                const blob = new Blob([response.data], { type: 'image/jpeg' })
                const urlCreator = window.URL || window.webkitURL
                const imageUrl = urlCreator.createObjectURL(blob)
                capturedFrame.value = imageUrl
                connectionTested.value = true
                emitStreamLinkData()
                toast.success(t('cameras.stream.connected'))
            } catch (error) {
                console.error('Camera connection test failed:', error)
                connectionError.value = true
                toast.error(t('cameras.stream.connectFailed', { message: error.message }))
            } finally {
                isLoading.value = false
            }
        }


        //Send data to parent when value of checkbox changes
        const emitStreamLinkData = () => {
          emit('streamlink', StreamLink.value)
          emit('capturedframe', capturedFrame.value)
        }

        const onCancel = () => {
          console.log('User cancelled the loader.')
        }

    
        return {
          StreamLink,
          capturedFrame,
          connectionError,
          testConnectCamera,
          connectionTested,
          isLoading,
          onCancel
        }
    }
}

</script>

<style scoped>
.block-head{ margin:10px 0 8px; color:#425461 }

.grid-inline{
  display:grid; grid-template-columns:1fr auto; gap:10px; align-items:center;
}
@media (max-width:680px){ .grid-inline{ grid-template-columns:1fr } }

.input{
  width:100%; border:1px solid #dfe7ee; border-radius:10px; padding:10px 12px;
  background:#fff; color:#2b3a44; outline:none;
}
.input:focus{ border-color:#4F7EB3; box-shadow:0 0 0 3px rgba(79,126,179,.12) }

.btn-solid{
  display:inline-flex; align-items:center; gap:8px; border:0; color:#fff;
  padding:10px 14px; border-radius:10px; cursor:pointer;
}
.btn-solid.primary{ background:#4F7EB3 }
.btn-solid.primary:hover{ filter:brightness(.96) }

.loading-wrap{ padding:16px 0 }
.loader{
  width:42px; padding:6px; aspect-ratio:1; border-radius:50%;
  background:#B2C149;
  --_m: conic-gradient(#0000 10%,#000), linear-gradient(#000 0 0) content-box;
  -webkit-mask:var(--_m); mask:var(--_m);
  -webkit-mask-composite:source-out; mask-composite:subtract;
  animation:spinner 1s linear infinite;
}
@keyframes spinner{ to{ transform:rotate(1turn) } }

.frame-container{ padding-top:10px }
</style>